/**
 * directory · 企业通讯录演示数据（L0 data 层）
 * ------------------------------------------------------------
 * 设计口径（2026-10-11，独立页 /directory 已删除，功能整体内嵌回聊天左栏）：
 * - 组织架构树最后一级到人（TreeNode.member）
 * - 「常用联系人」= 最近联系过的人（lastContactMin 升序），非手动收藏
 * - 外部联系人按伙伴（公司）组织：仅当「你负责该伙伴的对接管理」（Partner.managed）
 *   才可查看其下成员；未负责的伙伴成员锁定不可见
 * 经 repository.directoryRepo 对外提供；对接目录服务时替换实现、签名保持。
 */
export interface Member {
  id: string; name: string; title: string; dept: string; deptPath: string[]
  phone: string; empNo: string; joinDate: string; roles: string[]
  partTime?: { dept: string; title: string }[]
  online: boolean
  /** 最近联系时间（几分钟前）；undefined = 近期未联系（不出现在常用联系人） */
  lastContactMin?: number
  external?: boolean; co?: string
}

export const MEMBERS: Member[] = [
  { id: 'm01', name: '马剑',   title: '流程与信息化专员', dept: '企业管理部', deptPath: ['集团总部', '综合管理中心', '企业管理部'], phone: '138****6688', empNo: 'E30012', joinDate: '2024-03-18', roles: ['流程与信息化专员', '异常台账管理员'], partTime: [{ dept: '供应链部', title: '流程协同' }], online: true,  lastContactMin: 5 },
  { id: 'm02', name: '陈国强', title: '部长',             dept: '企业管理部', deptPath: ['集团总部', '综合管理中心', '企业管理部'], phone: '139****6601', empNo: 'E30003', joinDate: '2021-06-01', roles: ['部门负责人'], online: false, lastContactMin: 45 },
  { id: 'm03', name: '林晓雯', title: '供应链协调员',     dept: '供应链部',   deptPath: ['集团总部', '供应链中心', '供应链部'],     phone: '137****6210', empNo: 'E21047', joinDate: '2022-09-12', roles: ['供应链协调员', '跨组织调拨'], partTime: [{ dept: '制造部', title: '生产协同' }], online: true,  lastContactMin: 8 },
  { id: 'm04', name: '王振宇', title: '采购主管',         dept: '供应链部',   deptPath: ['集团总部', '供应链中心', '供应链部'],     phone: '136****6212', empNo: 'E21088', joinDate: '2023-02-20', roles: ['采购执行'], online: false },
  { id: 'm05', name: '赵婷婷', title: '财务共享审核',     dept: '财务部',     deptPath: ['集团总部', '财务中心', '财务部'],         phone: '135****6402', empNo: 'E19055', joinDate: '2020-11-09', roles: ['共享审核', '报销审批'], online: true,  lastContactMin: 1380 },
  { id: 'm06', name: '孙立群', title: '基地生产计划',     dept: '制造部',     deptPath: ['集团总部', '制造中心', '制造部'],         phone: '138****6315', empNo: 'E18022', joinDate: '2019-07-15', roles: ['生产计划', '排产'], online: true,  lastContactMin: 1450 },
  { id: 'm07', name: '周慧敏', title: 'HRBP',             dept: '人力资源部', deptPath: ['集团总部', '综合管理中心', '人力资源部'], phone: '133****6505', empNo: 'E22090', joinDate: '2023-05-08', roles: ['HRBP', '招聘'], online: false, lastContactMin: 4320 },
  { id: 'm08', name: '吴海涛', title: '设备管理主管',     dept: '制造部',     deptPath: ['集团总部', '制造中心', '制造部'],         phone: '139****6318', empNo: 'E17033', joinDate: '2018-04-23', roles: ['设备管理', '维保审批'], online: true,  lastContactMin: 120 },
  { id: 'm09', name: '郑雅文', title: '成本会计',         dept: '财务部',     deptPath: ['集团总部', '财务中心', '财务部'],         phone: '137****6408', empNo: 'E23061', joinDate: '2024-01-02', roles: ['成本核算'], online: false },
  { id: 'm10', name: '刘思远', title: '仓储主管',         dept: '供应链部',   deptPath: ['集团总部', '供应链中心', '供应链部'],     phone: '136****6220', empNo: 'E20119', joinDate: '2021-10-11', roles: ['仓储管理', '盘点'], online: true,  lastContactMin: 7200 },
  { id: 'x01', name: '梁文浩', title: '采购总监',         dept: '外部联系人', deptPath: ['外部好友'],                               phone: '135****2233', empNo: '—',       joinDate: '—',          roles: ['外部协作'], online: false, lastContactMin: 2880, external: true, co: '恒生五金有限公司' },
  { id: 'x02', name: '苏婷',   title: '对账专员',         dept: '外部联系人', deptPath: ['外部好友'],                               phone: '138****9090', empNo: '—',       joinDate: '—',          roles: ['外部协作'], online: true,  lastContactMin: 30,   external: true, co: '联达物流股份有限公司' },
  { id: 'x03', name: '何俊才', title: '业务对接经理',     dept: '外部联系人', deptPath: ['外部好友'],                               phone: '139****7755', empNo: '—',       joinDate: '—',          roles: ['外部协作'], online: true,  lastContactMin: 260,  external: true, co: '恒生五金有限公司' },
  { id: 'x04', name: '高蕾',   title: '运力调度',         dept: '外部联系人', deptPath: ['外部好友'],                               phone: '136****4142', empNo: '—',       joinDate: '—',          roles: ['外部协作'], online: false, external: true, co: '联达物流股份有限公司' },
  { id: 'x05', name: '袁世坤', title: '客户经理',         dept: '外部联系人', deptPath: ['外部好友'],                               phone: '137****8821', empNo: '—',       joinDate: '—',          roles: ['外部协作'], online: false, external: true, co: '华信包装制品厂' }
]

/* ---------- 大规模演示数据：确定性伪随机扩容至 ~1000 人（seed 固定，刷新不变） ----------
   原 15 人保留（对话与演示引用其身份）；追加成员 id 从 m1001 / x101 起，避免与既有 id 冲突。 */
function mulberry32(seed: number): () => number {
  return () => {
    seed |= 0; seed = (seed + 0x6D2B79F5) | 0
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}
const _rnd = mulberry32(20261011)
const _pick = <T,>(a: T[]): T => a[Math.floor(_rnd() * a.length)]

const GEN_SURNAMES = '王李张刘陈杨黄赵周吴徐孙马朱胡郭何高林罗郑梁谢宋唐许韩冯邓曹彭曾肖田董潘袁蔡蒋余于杜叶程魏苏吕丁任卢姚沈钟姜崔谭陆范汪廖石金韦贾夏付方邹熊白孟秦邱侯江尹薛闫段雷龙黎史陶贺顾毛郝龚邵万钱严赖覃洪武莫孔汤'
const GEN_GIVENS = ['伟', '芳', '娜', '敏', '静', '丽', '强', '磊', '军', '洋', '勇', '艳', '杰', '娟', '涛', '明', '超', '秀兰', '霞', '平', '刚', '桂英', '文轩', '雨欣', '子涵', '浩然', '梦琪', '志强', '晓东', '雅静', '俊杰', '雪梅', '海燕', '立新', '建华', '国庆', '春华', '淑华', '晨曦', '嘉怡', '思远', '佳琪', '文博', '天佑', '若彤', '锦程', '知行', '望舒', '清扬', '静姝']
const GEN_TITLES: Record<string, string[]> = {
  综合管理中心: ['专员', '主管', '经理', '高级专员', '部长', '副经理', '资深专员'],
  供应链中心: ['计划员', '主管', '经理', '协调员', '调度专员', '高级主管', '运营专员'],
  财务中心: ['会计', '主管', '高级会计', '经理', '核算专员', '资金专员', '审计师'],
  制造中心: ['工艺工程师', '班组长', '主管', '计划员', '质量工程师', '设备工程师', '经理'],
  市场营销中心: ['市场专员', '客户经理', '销售代表', '主管', '大区经理', '渠道经理', '品牌专员'],
  研发技术中心: ['工程师', '高级工程师', '架构师', '经理', '测试工程师', '产品经理', '研发主管'],
  行政运营中心: ['行政专员', '主管', '经理', '后勤专员', '安环专员'],
  数字与信息中心: ['运维工程师', '开发工程师', '数据工程师', '安全工程师', '主管', '高级工程师']
}
const GEN_ORG: { center: string; depts: { name: string; add: number }[] }[] = [
  { center: '综合管理中心', depts: [{ name: '企业管理部', add: 20 }, { name: '人力资源部', add: 24 }, { name: '法务部', add: 44 }] },
  { center: '供应链中心',   depts: [{ name: '供应链部', add: 22 }, { name: '采购部', add: 58 }, { name: '物流部', add: 62 }] },
  { center: '财务中心',     depts: [{ name: '财务部', add: 20 }, { name: '资金部', add: 40 }] },
  { center: '制造中心',     depts: [{ name: '制造部', add: 26 }, { name: '设备部', add: 46 }, { name: '质量部', add: 50 }] },
  { center: '市场营销中心', depts: [{ name: '市场部', add: 50 }, { name: '销售部', add: 78 }, { name: '客户服务部', add: 54 }] },
  { center: '研发技术中心', depts: [{ name: '研发中心', add: 74 }, { name: '产品部', add: 44 }, { name: '测试部', add: 56 }] },
  { center: '行政运营中心', depts: [{ name: '行政部', add: 40 }, { name: '安环部', add: 30 }] },
  { center: '数字与信息中心', depts: [{ name: '信息技术部', add: 64 }, { name: '数据服务部', add: 50 }, { name: '信息安全部', add: 34 }] }
]
const GEN_COMS = [
  { co: '恒生五金有限公司',     add: 18, titles: ['采购专员', '销售经理', '业务对接', '质检员', '仓管员', '对账专员'] },
  { co: '联达物流股份有限公司', add: 18, titles: ['运力调度', '司机队长', '调度专员', '客服专员', '结算专员', '运营经理'] },
  { co: '华信包装制品厂',       add: 19, titles: ['业务对接', '生产计划', '质检员', '客户经理', '仓管员'] }
]
;(function genDirectory() {
  const used = new Set(MEMBERS.map(m => m.name))
  let seq = 0
  const mkName = (): string => {
    for (let i = 0; i < 24; i++) {
      const nm = GEN_SURNAMES[Math.floor(_rnd() * GEN_SURNAMES.length)] + _pick(GEN_GIVENS)
      if (!used.has(nm)) { used.add(nm); return nm }
    }
    return `成员${++seq}`
  }
  let n = 1001
  for (const c of GEN_ORG) {
    const titles = GEN_TITLES[c.center]
    for (const d of c.depts) {
      for (let i = 0; i < d.add; i++) {
        const nc = _rnd() < 0.14
        MEMBERS.push({
          id: `m${n++}`, name: mkName(), title: _pick(titles), dept: d.name,
          deptPath: ['集团总部', c.center, d.name],
          phone: `13${_pick(['5', '6', '7', '8', '9'])}****${String(1000 + Math.floor(_rnd() * 9000))}`,
          empNo: `E${31000 + n}`, joinDate: `${2018 + Math.floor(_rnd() * 8)}-${String(1 + Math.floor(_rnd() * 12)).padStart(2, '0')}-${String(1 + Math.floor(_rnd() * 28)).padStart(2, '0')}`,
          roles: [_pick(titles)], online: nc,
          lastContactMin: _rnd() < 0.05 ? Math.floor(_rnd() * 10000) + 20 : undefined
        })
      }
    }
  }
  let x = 101
  for (const g of GEN_COMS) {
    for (let i = 0; i < g.add; i++) {
      const nc = _rnd() < 0.1
      MEMBERS.push({
        id: `x${x++}`, name: mkName(), title: _pick(g.titles), dept: '外部联系人', deptPath: ['外部好友'],
        phone: `13${_pick(['5', '6', '7', '8', '9'])}****${String(1000 + Math.floor(_rnd() * 9000))}`,
        empNo: '—', joinDate: '—', roles: ['外部协作'], online: nc,
        lastContactMin: _rnd() < 0.2 ? Math.floor(_rnd() * 8000) + 15 : undefined,
        external: true, co: g.co
      })
    }
  }
})()

/** 外部伙伴：managed = 你负责该伙伴的对接管理（才可查看其下成员） */
export interface Partner { id: string; name: string; managed: boolean; members: Member[] }
export const PARTNERS: Partner[] = [
  { id: 'p1', name: '恒生五金有限公司',     managed: true,  members: MEMBERS.filter(m => m.co === '恒生五金有限公司') },
  { id: 'p2', name: '联达物流股份有限公司', managed: true,  members: MEMBERS.filter(m => m.co === '联达物流股份有限公司') },
  { id: 'p3', name: '华信包装制品厂',       managed: false, members: MEMBERS.filter(m => m.co === '华信包装制品厂') }
]

export interface TreeNode { label: string; count: number; path: string; member?: Member; children?: TreeNode[] }

/** 内部成员组织树：公司（根）→ 中心 → 部门 → 人（最后一级到人）；根节点=当前组织最高级公司 */
export function buildOrgTree(rootLabel = '集团总部'): TreeNode {
  const root: TreeNode = { label: rootLabel, count: 0, path: rootLabel, children: [] }
  const centers = new Map<string, Map<string, Member[]>>()
  for (const m of MEMBERS) {
    if (m.external) continue
    const [, center, dept] = m.deptPath
    if (!centers.has(center)) centers.set(center, new Map())
    const depts = centers.get(center)!
    if (!depts.has(dept)) depts.set(dept, [])
    depts.get(dept)!.push(m)
  }
  for (const [center, depts] of centers) {
    const node: TreeNode = { label: center, count: 0, path: center, children: [] }
    for (const [dept, ms] of depts) {
      const dNode: TreeNode = { label: dept, count: ms.length, path: center + '/' + dept, children: [] }
      for (const m of ms) dNode.children!.push({ label: m.name, count: 0, path: dNode.path + '/' + m.id, member: m })
      node.children!.push(dNode)
      node.count += ms.length
    }
    root.children!.push(node)
  }
  root.count = MEMBERS.length - MEMBERS.filter(m => m.external).length
  return root
}

/** 常用联系人 = 最近联系过的人（升序） */
export function recents(): Member[] {
  return MEMBERS.filter(m => m.lastContactMin !== undefined).sort((a, b) => a.lastContactMin! - b.lastContactMin!)
}

/* ---------- 成员档案派生：岗位职责与进行中的工作 ----------
   按职称/所属中心确定性生成（同人恒定），演示千人体量下的档案细化；M2+ 由 HR 与流程服务按人下发。 */
export interface MemberWork { name: string; node: string; prog: number; due: string }
export interface MemberProfile { duties: string[]; works: MemberWork[] }

const DUTY_BY_ROLE: [RegExp, string[]][] = [
  [/部长|总监/, ['统筹部门年度目标与预算，对交付结果负责', '审批部门内关键业务动作与资源调配', '跨部门协同与向上汇报，推动重点事项闭环', '团队建设：招聘、培养与绩效管理']],
  [/主管/, ['制定本领域工作计划并分配任务，把控质量与进度', '处理例外与升级事项，牵头跨环节协调', '辅导团队成员，沉淀操作规范与检查清单']],
  [/经理/, ['对所辖业务线的经营指标与客户满意度负责', '制定并优化业务流程，组织例会复盘', '协调上下游资源，管理风险与优先级']],
  [/工程师|架构师/, ['按规范完成设计与开发交付，保证质量与可维护性', '参与方案评审，输出技术文档与验收标准', '响应线上问题，定位根因并推动修复']],
  [/会计|审计|核算|资金/, ['按准则完成核算与审核，确保账实相符与合规', '编制报表与状态报告，支持审计与稽核', '识别资金与税务风险，及时上报例外']],
  [/计划|调度|协调/, ['编制与维护计划排程，跟踪执行偏差并纠偏', '协调资源冲突，平衡优先级与交期', '输出日/周报，同步异常与风险']],
  [/专员|审核|客服|人事|办事|代表/, ['按标准作业流程完成日常业务处理', '对经手数据的真实、完整、及时负责', '发现异常按升级路径上报并跟踪闭环']]
]
const DUTY_COMMON = ['对经手业务的真实性、合规性与及时性负责', '执行公司信息安全与数据保密要求', '按流程留痕，配合审计与内外部检查']
const WORK_TPL: Record<string, { name: string; node: string }[]> = {
  综合管理中心: [
    { name: '制度文件年度修订', node: '制度管理 / 发布评审' },
    { name: '内审问题整改跟踪', node: '内审 / 整改验证' },
    { name: '季度绩效考核组织', node: '绩效管理 / 评估校准' },
    { name: '招聘需求汇总与面试安排', node: '招聘 / 面试安排' }
  ],
  供应链中心: [
    { name: '供应商对账与差异处理', node: '对账结算 / 差异核销' },
    { name: '跨组织调拨执行', node: '调拨 / 在途跟踪' },
    { name: '到货验收异常处理', node: '验收 / 异常处置' },
    { name: '采购订单来源核验', node: '订单管理 / 来源核验' },
    { name: '安全库存参数复核', node: '库存策略 / 参数复核' }
  ],
  财务中心: [
    { name: '月度结账与报表编制', node: '总账 / 结账' },
    { name: '费用报销单审核', node: '共享审核 / 单据审核' },
    { name: '成本分摊规则校验', node: '成本 / 分摊计算' },
    { name: '银行对账单核对', node: '资金 / 对账' }
  ],
  制造中心: [
    { name: '周排产计划编制', node: '生产计划 / 排产' },
    { name: '设备预防性巡检', node: '设备管理 / 巡检工单' },
    { name: '来料质量异常处置', node: '质量管理 / 异常单' },
    { name: '工单报工与工时核对', node: '生产执行 / 报工' }
  ],
  市场营销中心: [
    { name: '重点客户回访计划', node: '客户管理 / 回访执行' },
    { name: '促销活动效果复盘', node: '营销活动 / 复盘' },
    { name: '渠道订单交付跟踪', node: '订单履约 / 跟踪' },
    { name: '客户投诉工单处理', node: '服务台 / 工单处理' }
  ],
  研发技术中心: [
    { name: '迭代需求评审与排期', node: '研发管理 / 迭代评审' },
    { name: '接口联调与缺陷修复', node: '开发 / 联调测试' },
    { name: '技术方案评审材料准备', node: '架构治理 / 方案评审' },
    { name: '线上问题根因分析', node: '运维 / 问题单' }
  ],
  行政运营中心: [
    { name: '办公物资盘点', node: '行政 / 资产盘点' },
    { name: '安环隐患排查整改', node: '安环 / 隐患闭环' },
    { name: '会议与接待保障安排', node: '行政服务 / 保障' }
  ],
  数字与信息中心: [
    { name: '账号权限季度复核', node: '身份权限 / 权限复核' },
    { name: '主数据质量专项治理', node: '主数据 / 质量治理' },
    { name: '系统巡检与备份验证', node: 'IT 运维 / 巡检' },
    { name: '集成接口监控告警处理', node: '集成监控 / 告警处置' }
  ]
}
const EXT_WORKS = [
  { name: '合同条款确认与回签', node: '外部协作 / 合同' },
  { name: '供货计划对齐', node: '外部协作 / 供货计划' },
  { name: '对账单确认', node: '外部协作 / 对账' }
]
function hashOf(s: string): number {
  let h = 0
  for (const ch of s) h = (h * 31 + ch.charCodeAt(0)) | 0
  return Math.abs(h)
}
export function memberProfile(m: Member): MemberProfile {
  const h = hashOf(m.id)
  const row = DUTY_BY_ROLE.find(([re]) => re.test(m.title))
  const duties = [...(row ? row[1] : [])]
  duties.push(DUTY_COMMON[h % DUTY_COMMON.length])
  if (duties.length < 4) duties.push(DUTY_COMMON[(h + 1) % DUTY_COMMON.length])
  const pool = m.external ? EXT_WORKS : (WORK_TPL[m.deptPath[1]] ?? EXT_WORKS)
  const cnt = 2 + (h % 2)
  const works: MemberWork[] = []
  for (let i = 0; i < cnt; i++) {
    const w = pool[(h + i * 3) % pool.length]
    if (works.some(x => x.name === w.name)) continue
    works.push({ ...w, prog: 15 + ((h >> (i + 1)) % 80), due: `${1 + ((h >> (i + 3)) % 12)} 天后到期` })
  }
  return { duties, works }
}
